import { Controller } from "@hotwired/stimulus"
import Swal from 'sweetalert2';
import { format } from 'date-fns';
import axios from "axios";

import getFriendlyErrorMessage from '../../javascript/helpers/getFriendlyErrorMessage';
import { hideModalCarregando, showModalCarregando } from "../../javascript/modal-carregando";

export default class extends Controller {
  selected = new Set();

  onItemClick(e) {
    const target = e.target;

    if (target.name == 'marcar_todos_relatorios') {
      const itens = document.getElementsByName('relatorio_individual');
      for (let item of itens) {
        if (target.checked) {
          this.selected.add(item.value);
          item.checked = true;
        } else {
          item.checked = false;
          this.selected.clear();
        }
      }
    } else if (target.checked) {
      this.selected.add(target.value);
    } else {
      this.selected.delete(target.value);
      if (this.selected.size == 0) document.querySelector("#marcar_todos_relatorios").checked = false;
    }

    this.updateAlerta();
  }


  updateAlerta() {
    const element = document.getElementById('alerta-relatorios-selecionados');

    if (this.selected.size == 0) {
      // element.style.display = 'none';
      element.close();
      return;
    }

    const mensagem = this.selected.size == 1 ? '1 relatório selecionado' : `${this.selected.size} relatórios selecionados`;
    const textoBotaoEnvio = this.selected.size == 1 ? 'Prorrogar envio do relatório' : 'Prorrogar envio dos relatórios';
    const textoBotaoPreenchimento = 'Prorrogar prazo de preenchimento';
    const p = element.querySelector('p');
    p.innerHTML = mensagem;
    const botoes = element.querySelectorAll('button[type="button"]');
    if (botoes.length > 0) {
      botoes[0].innerHTML = textoBotaoPreenchimento;
    }
    if (botoes.length > 1) {
      botoes[1].innerHTML = textoBotaoEnvio;
    }
    element.style.position = "fixed"; // Mantém a modal fixa sem rolar a página
    element.show();

    if (!element.dataset.listenersAdded) {
      document.getElementById("fechar-modal").addEventListener("click", () => {
        element.close();
      });

      element.dataset.listenersAdded = "true"; // Evita adicionar eventos duplicados
    }
  }

  async confirmarAcaoDesfazerSolicitacaoCorrecao(e) {
    const id = e.target.getAttribute('data-id-relatorio');
    const situacao = e.target.getAttribute('data-situacao-relatorio');
    const nomeServidor = e.target.getAttribute('data-nome-servidor-relatorio');
    if (!id) {
      return;
    }

    const mensagem = `Tem certeza de que deseja desfazer a solicitação de correção do relatório nº ${id} de ${nomeServidor}?`
    const result = await Swal.fire({
      icon: 'question',
      title: mensagem,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Confirmar'
    });

    if (result.isConfirmed) {
      showModalCarregando("Processando... Aguarde.");

      try {
        await axios.post(`/gerenciar-relatorios/${id}/desfazer_solicitacao_correcao`);

        await Swal.fire({
          title: "Relatório alterado com sucesso",
          confirmButtonText: 'Ok',
          icon: 'success'
        })

        window.location.reload();
      } catch (err) {
        const message = getFriendlyErrorMessage(err, "Por favor, tente novamente");

        Swal.fire({
          title: "Houve um erro ao processar os dados",
          text: message,
          confirmButtonText: 'Ok',
          icon: 'error'
        })
      }

      hideModalCarregando();
    }
  }

  async confirmarAcaoDesfazerAprovacaoRejeicao(e) {
    const id = e.target.getAttribute('data-id-relatorio');
    const situacao = e.target.getAttribute('data-situacao-relatorio');
    const nomeServidor = e.target.getAttribute('data-nome-servidor-relatorio');
    if (!id) {
      return;
    }

    const mensagem = `Tem certeza de que deseja desfazer a ${situacao == 'aprovado' ? 'aprovação' : 'rejeição'} do relatório nº ${id} de ${nomeServidor}?`
    const result = await Swal.fire({
      icon: 'question',
      title: mensagem,
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      showConfirmButton: true,
      confirmButtonText: 'Confirmar'
    });

    if (result.isConfirmed) {
      showModalCarregando("Processando... Aguarde.");

      try {
        await axios.post(`/gerenciar-relatorios/${id}/desfazer_aprovacao_rejeicao`);

        await Swal.fire({
          title: "Relatório alterado com sucesso",
          confirmButtonText: 'Ok',
          icon: 'success'
        })

        window.location.reload();
      } catch (err) {
        const message = getFriendlyErrorMessage(err, "Por favor, tente novamente");

        Swal.fire({
          title: "Houve um erro ao processar os dados",
          text: message,
          confirmButtonText: 'Ok',
          icon: 'error'
        })
      }

      hideModalCarregando();
    }

    console.log(id, situacao, nomeServidor)
  }

  async exibirModal() {
    if (this.selected.size == 0) return;

    const element = document.getElementById('alerta-relatorios-selecionados');
    element.close(); // Fecha a modal antes de abrir o SweetAlert

    const mensagem = this.selected.size == 1 ? '1 relatório selecionado' : `${this.selected.size} relatórios selecionados`;
    const today = format(new Date(), 'yyyy-MM-dd');
    const { value: dataFimEnvio } = await Swal.fire({
      title: mensagem,
      input: "date",
      inputLabel: "Nova data de fim do envio",
      inputAttributes: { min: today, required: true },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Salvar',
      async preConfirm(value) {
        const result = await Swal.fire({
          title: 'Tem certeza de que deseja prorrogar o envio destes relatórios? Esta ação não poderá ser desfeita.',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          confirmButtonText: 'Sim'
        })

        if (result.dismiss) {
          return false;
        }
      }
    });

    if (dataFimEnvio) {
      try {
        showModalCarregando("Processando... Aguarde.");
        await axios.post('/gerenciar-relatorios/update_em_lote', {
          atributos: {
            data_fim_envio: dataFimEnvio
          },
          relatorios_ids: Array.from(this.selected)
        });

        const url = new URL(window.location);
        url.searchParams.set('notice', "Relatórios atualizados com sucesso!");
        window.location.href = url.href;
      } catch (err) {
        let message;

        if (err?.response?.data && Array.isArray(err.response.data)) {
          message = err.response.data.join(' ');
        } else {
          message = getFriendlyErrorMessage(err, "Houve um erro ao processar os dados. Por favor, tente novamente");
        }

        hideModalCarregando();
        Swal.fire({
          title: "Houve um erro ao processar os dados",
          text: message,
          confirmButtonText: 'Ok'
        })
      }
    }
  }

  async exibirModalPreenchimento() {
    if (this.selected.size == 0) return;

    const element = document.getElementById('alerta-relatorios-selecionados');
    element.close(); // Fecha a modal antes de abrir o SweetAlert

    const mensagem = this.selected.size == 1 ? '1 relatório selecionado' : `${this.selected.size} relatórios selecionados`;
    const today = format(new Date(), 'yyyy-MM-dd');
    const { value: dataFimPreenchimento } = await Swal.fire({
      title: mensagem,
      input: "date",
      inputLabel: "Nova data de fim de preenchimento",
      inputAttributes: { min: today, required: true },
      showCancelButton: true,
      cancelButtonText: 'Cancelar',
      confirmButtonText: 'Salvar',
      async preConfirm(value) {
        const result = await Swal.fire({
          title: 'Tem certeza de que deseja prorrogar o prazo de preenchimento destes relatórios? Esta ação não poderá ser desfeita.',
          cancelButtonText: 'Cancelar',
          showCancelButton: true,
          confirmButtonText: 'Sim'
        })

        if (result.dismiss) {
          return false;
        }
      }
    });

    if (dataFimPreenchimento) {
      try {
        showModalCarregando("Processando... Aguarde.");
        await axios.post('/gerenciar-relatorios/update_em_lote', {
          atributos: {
            data_fim_preenchimento_servidor: dataFimPreenchimento
          },
          relatorios_ids: Array.from(this.selected)
        });

        const url = new URL(window.location);
        url.searchParams.set('notice', "Relatórios atualizados com sucesso!");
        window.location.href = url.href;
      } catch (err) {
        let message;

        if (err?.response?.data && Array.isArray(err.response.data)) {
          message = err.response.data.join(' ');
        } else {
          message = getFriendlyErrorMessage(err, "Houve um erro ao processar os dados. Por favor, tente novamente");
        }

        hideModalCarregando();
        Swal.fire({
          title: "Houve um erro ao processar os dados",
          text: message,
          confirmButtonText: 'Ok'
        })
      }
    }
  }
}